import { apiFetch, API_URL, obterToken } from './apiClient';

/* Certificados digitais dos clientes. Criar/editar vão como FormData
   (arquivo .pfx junto), por isso não passam pelo apiFetch, que força
   Content-Type JSON. `diasRestantes` vem do backend, pelo mesmo motivo
   das procurações (fuso da máquina não pode mudar a cor). */
export const listarCertificados = () => apiFetch('/certificados');
/* empresas (CNPJ) sem e-CNPJ válido -- aba "Falta certificado" */
export const listarFaltandoCertificado = () => apiFetch('/certificados/faltando');
export const dispensarCertificado = (clienteId, motivo) => apiFetch('/certificados/dispensas', { method: 'POST', body: JSON.stringify({ cliente_id: clienteId, motivo }) });
export const revogarDispensaCertificado = (id) => apiFetch(`/certificados/dispensas/${id}/revogar`, { method: 'POST' });
export const avisoCertificados = () => apiFetch('/certificados/aviso');
export const darCienciaCertificados = () => apiFetch('/certificados/ciencia', { method: 'POST' });

export const excluirCertificado = (id) =>
  apiFetch(`/certificados/${id}`, { method: 'DELETE' });

/* a senha não vem na listagem -- só sob pedido, e cada pedido fica na
   auditoria */
export const buscarSenhaCertificado = (id) =>
  apiFetch(`/certificados/${id}/senha`).then(r => r.senha);

async function enviar(path, method, dados, arquivo) {
  const form = new FormData();
  Object.entries(dados).forEach(([k, v]) => {
    if (v !== undefined && v !== null) form.append(k, v);
  });
  if (arquivo) form.append('arquivo', arquivo);
  const token = obterToken();
  const response = await fetch(`${API_URL}${path}`, {
    method,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });
  const json = await response.json();
  if (!response.ok) throw new Error(json.error || 'Erro ao salvar o certificado');
  return json;
}

export const criarCertificado = (dados, arquivo) => enviar('/certificados', 'POST', dados, arquivo);

export const atualizarCertificado = (id, dados, arquivo) =>
  enviar(`/certificados/${id}`, 'PATCH', dados, arquivo);

/* baixa com o nome original do arquivo (o backend manda no
   Content-Disposition, mas num download via blob quem dá o nome é o
   atributo `download` do link) */
export async function baixarCertificado(id, nomeArquivo) {
  const token = obterToken();
  const response = await fetch(`${API_URL}/certificados/${id}/arquivo`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!response.ok) {
    let mensagem = 'Erro ao baixar o certificado';
    try { mensagem = (await response.json()).error || mensagem; } catch {}
    throw new Error(mensagem);
  }
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nomeArquivo || 'certificado.pfx';
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
